export default {
  folder: "x70-fl",
  totalFrames: 7,
  navFrame: 1,
  interior: {
    points: [
      [2500, -500, 0], // 10.1 Inches Touch-screen Infotainment System
      [-2000, -400, 0], // 7 Seater Capacity
      [2500, -600, -700], // Multi-function D-type Steering Wheel
      [2500, -500, -1000], // Dynamic Digital Dials
      [1800, -950, 75], // Wireless Charging
    ],
  },
  exterior: {
    hotspots: {
      h1: {
        // Matrix LED Smart Day Light
        popup: 1,
        point: [
          [43, 50], // f1
          [14, 51], // f2
          null, // f3
          null, // f4
          [88, 52], // f5
          [71, 54], // f6
          [64, 50], // f7
        ],
      },
      h2: {
        // 20 inch alloy wheels
        popup: 2,
        point: [
          [53, 71], // f1
          [25, 71], // f2
          [46, 69], // f3
          null, // f4
          [26, 73], // f5
          [58, 76], // f6
          null, // f7
        ],
      },
      h3: {
        // LED Tail Lights
        popup: 3,
        point: [
          null, // f1
          null, // f2
          [56, 40], // f3
          [35, 40], // f4
          [12, 44], // f5
          null, // f6
          null, // f7
        ],
      },
      h4: {
        // Panoramic Sunroof
        popup: 4,
        point: [
          [52, 23], // f1
          [54, 24], // f2
          [47, 22], // f3
          [49, 21], // f4
          [47, 24], // f5
          [47, 24], // f6
          [49, 20], // f7
        ],
      },
      h5: {
        // 1.5L Turbo Engine
        popup: 5,
        point: [
          [37, 45], // f1
          [23, 45], // f2
          [25, 45], // f3
          null, // f4
          [76, 46], // f5
          [71, 45], // f6
          [50, 44], // f7
        ],
      },
    },
  },
};
